import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import { c as classnames } from './index-5d9a618b.js';
import { t as tryParse } from './index-e29b327a.js';
import './_commonjsHelpers-11ca3be1.js';
import './currency-7be6806c.js';
import './lodash-bd96d09c.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';

const COMPARATOR_THRESHOLD = 4;
const COMPARATOR_PDF_WIDTH = 595;
const COMPARATOR_CHARATERISTIC_COLUMN_WIDTH = 180;

const pdfComparatorTableCss = ":host{display:block}td.comparator-cell{font-size:8px;word-wrap:break-word}.section-title{font-weight:700;font-family:\"ArialRoundedMTforSE-Bold\", sans-serif;padding:8px}.section-title>.comparator-cell{border-bottom:2px solid rgba(0, 0, 0, 0.5)}.characteristic-cell{font-family:\"ArialRoundedMTforSE-Regular\", sans-serif}.title-cell{font-family:\"ArialRoundedMTforSE-Bold\", sans-serif;width:126px;border-bottom:1px}.section-url{text-decoration:none;color:#42b4e6}.section-title{line-height:20px}.comparator-border-cell{border:1px solid #cbcbcb;padding:8px}.highlight{background-color:#fafafa}";

const PdfComparatorTable = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.keySections = undefined;
    this.sections = undefined;
    this.items = undefined;
    this.runtimeInfo = undefined;
    this.hideSimilarties = undefined;
    this.characteristicsMap = undefined;
    this.totalProducts = undefined;
  }
  renderSection(row) {
    return (h("tr", { class: "section-title" }, h("td", { class: "comparator-cell", colSpan: this.totalProducts + 1 }, row.name)));
  }
  mapCharecteristicArray(valuesArray, urlArray) {
    return valuesArray.map((value, index) => {
      if (urlArray[index] !== null)
        return this.renderCharacteristicWithUrl(value, urlArray[index]);
      return h("p", null, value);
    });
  }
  renderCharacteristicWithUrl(value, url) {
    return (h("a", { href: url, class: "section-url" }, value));
  }
  renderCharacteristic(row) {
    var _a;
    const getCharacteristic = (charecteristic) => {
      if (!charecteristic)
        return;
      if (!charecteristic.url)
        return charecteristic.value;
      if (Array.isArray(charecteristic.url) && Array.isArray(charecteristic.value)) {
        return this.mapCharecteristicArray(charecteristic.value, charecteristic.url);
      }
      return this.renderCharacteristicWithUrl(charecteristic.value, charecteristic.url);
    };
    const isOneProduct = row.charecteristics.length === 1;
    const availableWidth = COMPARATOR_PDF_WIDTH - COMPARATOR_CHARATERISTIC_COLUMN_WIDTH;
    const cWidth = availableWidth / row.charecteristics.length;
    return (h("tr", { class: "d-flex-row" }, h("td", { class: "highlight comparator-border-cell title-cell comparator-cell" }, row.label), (_a = row.charecteristics) === null || _a === void 0 ? void 0 :
      _a.map((c) => (h("td", { class: classnames(!row.hidable && !isOneProduct && 'highlight', 'comparator-border-cell', 'characteristic-cell', 'comparator-cell'), style: { width: `${cWidth}px` } }, getCharacteristic(c))))));
  }
  render() {
    var _a;
    return (h(Host, null, (_a = this.characteristicsMap) === null || _a === void 0 ? void 0 : _a.map((row) => {
      if (row.isSection)
        return this.renderSection(row);
      return this.renderCharacteristic(row);
    })));
  }
};
PdfComparatorTable.style = pdfComparatorTableCss;

const pesComparatorHeaderCss = ":host{display:block}.header-container{border-bottom:2px solid rgba(0, 0, 0, 0.5)}.header{font-size:22px;font-weight:700;height:30px;line-height:30px;font-family:\"ArialRoundedMTforSE-Bold\", sans-serif;margin-top:10px;margin-bottom:0}.pdf-rtl-selector:not([dir=\"rtl\"]) .header{padding-left:24px}.pdf-rtl-selector[dir=\"rtl\"] .header{padding-right:24px}.date{font-size:10px;font-family:\"ArialRoundedMTforSE-Regular\", sans-serif}.pdf-rtl-selector:not([dir=\"rtl\"]) .date{padding-left:24px}.pdf-rtl-selector[dir=\"rtl\"] .date{padding-right:24px}";

const PesComparatorHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.title = undefined;
    this.date = undefined;
  }
  render() {
    return (h(Host, null, h("div", { class: "header-container" }, h("p", { class: "header" }, this.title), h("p", { class: "date" }, this.date))));
  }
};
PesComparatorHeader.style = pesComparatorHeaderCss;

const pesComparatorProductHeadCss = "th.columns .product-card{font-weight:normal}.main-container-comparator{position:running(main-container-comparator)}.main-container-comparator{margin:8px}.items-label{font-size:8px;color:#333;margin-top:-54px;font-family:\"ArialRoundedMTforSE-Regular\", sans-serif}.items-label-column{display:table-cell;margin:0}.bold{font-weight:bold}.product-card{border:1px solid #cbcbcb}.product-card-CR{margin:5px 8px 5px 8px;font-size:5px;color:#626469;line-height:10px;font-family:\"ArialRoundedMTforSE-Regular\", sans-serif}.pdp-url{font-size:6px;margin:5px 8px 5px 8px;line-height:10px;font-weight:700;color:#42b4e6;font-family:\"ArialRoundedMTforSE-Bold\", sans-serif}.product-card-price{font-weight:700;font-size:8px;margin:5px 8px 5px 8px;line-height:10px;font-family:\"ArialRoundedMTforSE-Bold\", sans-serif}.product-card-description{font-size:6px;font-weight:700;margin:5px 8px 5px 8px;color:#42b4e6;font-family:\"ArialRoundedMTforSE-Bold\", sans-serif}.product-card-img-container{text-align:center}.product-card-img{width:120px;height:120px;margin:auto auto}.product-card-description>span{color:#333;font-size:6px}.pdp-url>a{text-decoration:none;color:#219bfd}.product-card-img-bundled{text-align:center}img.item_top{height:60px;width:60px;z-index:3;position:relative}img.item_bottom{margin-top:-52px;position:relative;width:70px;height:70px;z-index:2}.product-card-img-bundled>img{border:1px solid #333}";

const PesComparatorProductHead = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.labels = undefined;
    this.products = undefined;
    this.start = undefined;
    this.end = undefined;
    this.totalLength = undefined;
    this.prices = undefined;
    this.aux = undefined;
  }
  renderBundledProduct(product, index, productUrl) {
    var _a, _b;
    const bundledProductUrl = (_a = product.bundle.pdpPublicUrl) !== null && _a !== void 0 ? _a : '';
    return (h("th", { class: "columns product-card" }, h("div", null, h("div", { class: "product-card-img-bundled" }, h("div", { class: "item_top_container" }, h("img", { class: "item_top", src: product.pictureUrl, alt: product.pictureAltText })), h("div", { class: "item_bottom_container" }, h("img", { class: "item_bottom", src: (_b = this.aux[index].auxiliaryProduct) === null || _b === void 0 ? void 0 : _b.skuList[0].imageBean.midDimensionUrl, alt: "" }))), h("div", { class: "product-card-description pdp-url" }, h("a", { href: productUrl }, h("span", null, "x1"), product.description), h("span", null, `+ x${product.bundle.quantity}`), h("a", { href: bundledProductUrl }, product.bundle.description)))));
  }
  renderProductCard(product, index) {
    var _a, _b;
    const productUrl = (_a = product.pdpPublicUrl) !== null && _a !== void 0 ? _a : '';
    if (product.bundle)
      return this.renderBundledProduct(product, index, productUrl);
    let priceWithCurrency = '';
    if (this.prices[index] && this.prices[index].price) {
      if (this.prices[index].priceTooltip) {
        priceWithCurrency = `${this.prices[index].price}<sup>1</sup>`;
      }
      else {
        priceWithCurrency = `${this.prices[index].price}`;
      }
    }
    return (h("th", { class: "columns product-card" }, h("div", { class: "product-card-img-container" }, h("img", { class: "product-card-img", src: product === null || product === void 0 ? void 0 : product.pictureUrlComparatorPDF, alt: product === null || product === void 0 ? void 0 : product.pictureAltText })), h("div", { class: "product-card-CR" }, product === null || product === void 0 ? void 0 : product.commercialReference), h("div", { class: "product-card-description" }, product === null || product === void 0 ? void 0 : product.description), priceWithCurrency ? (h("div", { class: "product-card-price", innerHTML: priceWithCurrency })) : null, (product === null || product === void 0 ? void 0 : product.pdpPublicUrl) && ((_b = this.labels) === null || _b === void 0 ? void 0 : _b.viewDetailsLabel) ? (h("div", { class: "pdp-url" }, h("a", { href: product.pdpPublicUrl }, this.labels.viewDetailsLabel))) : null));
  }
  render() {
    var _a;
    return (h(Host, null, h("tr", { class: "product-card-container" }, h("th", { class: "columns items-label-column" }, h("p", { class: "items-label" }, "Items", h("span", { class: "bold" }, ` ${this.start} - ${this.end} `), "of ", this.totalLength)), (_a = this.products) === null || _a === void 0 ? void 0 :
      _a.map((product, index) => this.renderProductCard(product, index)))));
  }
};
PesComparatorProductHead.style = pesComparatorProductHeadCss;

const pesComparatorWeeePriceCss = "@page {\n  padding-bottom: 3%;\n\n  @left-bottom {\n    content: element(weee-price-label);\n  }\n}\n\n.weee-price-label {\n  width: 540px;\n  position: running(weee-price-label);\n  font-family: \"Arial Unicode MS\", Arial, sans-serif;\n  font-size: 9px;\n  color: #333;\n  letter-spacing: 0;\n  line-height: 15px;\n}\n\n.pdf-rtl-selector:not([dir=\"rtl\"]) .weee-price-label {\n  margin-left: 57px;\n}\n\n.pdf-rtl-selector[dir=\"rtl\"] .weee-price-label {\n  margin-right: 57px;\n}";

const PesComparatorWeeePrice = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.label = undefined;
  }
  render() {
    return (h("div", { class: "pdf-rtl-selector" }, h("p", { class: "weee-price-label" }, h("sup", null, "1"), this.label)));
  }
};
PesComparatorWeeePrice.style = pesComparatorWeeePriceCss;

const comparatorMapCharacteristics = (productIds, charactersictics) => {
  const table = [];
  for (const section of charactersictics.sections) {
    table.push({ isSection: true, name: section.name });
    for (const p of Object.keys(section.parameters)) {
      table.push(Object.assign({ key: p }, section.parameters[p]));
    }
  }
  const mainMap = [];
  for (const row of table) {
    if (row.isSection) {
      mainMap.push(row);
      continue;
    }
    const mainRow = row;
    mainRow.charecteristics = productIds.map((product) => (charactersictics.items[product] && charactersictics.items[product][row.key]
      ? charactersictics.items[product][row.key]
      : null));
    mainMap.push(mainRow);
  }
  return mainMap;
};

const pesComparisonPdfCss = "@page {\n  width: 595px;\n  height: 975px;\n  counter-increment: page;\n  width: 710px;\n}\n\n@page {\n  margin-top: 50px;\n}\n\n@page :first {\n  margin-top: 30px;\n}\n\n@page {\n  @right-middle {\n    content: element(disclaimer);\n    width: 730px;\n    margin-left: -306px;\n  }\n}\n\n.pdf-rtl-selector:not([dir=\"rtl\"]) .comparator-table {\n  margin-left: 50px;\n}\n\n.pdf-rtl-selector[dir=\"rtl\"] .comparator-table {\n  margin-right: 50px;\n}\n\n.comparator-table > tr {\n  page-break-inside: avoid;\n}\n\n.comparator-table > table {\n  border-spacing: 0;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.pdf-rtl-selector:not([dir=\"rtl\"]) .comparator-table > table {\n  text-align: left;\n}\n\n.pdf-rtl-selector[dir=\"rtl\"] .comparator-table > table {\n  text-align: right;\n}\n\n.table-container {\n  page-break-after: always;\n}";

const PesComparisonPdf = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.showWeePriceLabel = false;
    this.weePriceLabel = null;
    this._comparatorLabels = undefined;
    this._comparatorCharacteristics = undefined;
    this._comparatorPriceInfo = undefined;
    this.comparatorLabels = undefined;
    this.comparatorCharacteristics = undefined;
    this.comparatorPriceInfo = undefined;
    this.brand = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.comparatorLabels = (_a = tryParse(this._comparatorLabels)) !== null && _a !== void 0 ? _a : this.comparatorLabels;
    this.comparatorCharacteristics = (_b = tryParse(this._comparatorCharacteristics)) !== null && _b !== void 0 ? _b : this.comparatorCharacteristics;
    this.comparatorPriceInfo = (_c = tryParse(this._comparatorPriceInfo)) !== null && _c !== void 0 ? _c : this.comparatorPriceInfo;
  }
  getWEEEPriceLabel() {
    var _a;
    for (const item of this.comparatorPriceInfo.productsList) {
      if (!((_a = item.baseProduct) === null || _a === void 0 ? void 0 : _a.priceInfo))
        continue;
      const { priceInfo } = item.baseProduct;
      if ((priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.price) && (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.priceTooltip)) {
        this.showWeePriceLabel = true;
        this.weePriceLabel = priceInfo.priceTooltip;
        return;
      }
    }
    this.weePriceLabel = null;
  }
  doPricingMapping() {
    var _a, _b, _c, _d;
    const priceIdPriceMap = [];
    for (const item of this.comparatorPriceInfo.productsList) {
      if (!((_a = item.baseProduct) === null || _a === void 0 ? void 0 : _a.productId) || !((_b = item.baseProduct) === null || _b === void 0 ? void 0 : _b.priceInfo))
        continue;
      const productId = (_c = item.baseProduct) === null || _c === void 0 ? void 0 : _c.productId;
      const priceInfo = (_d = item.baseProduct) === null || _d === void 0 ? void 0 : _d.priceInfo;
      priceIdPriceMap.push({
        productId,
        price: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.formattedPriceWithCurrency,
        priceTooltip: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.priceTooltip,
      });
    }
    return priceIdPriceMap;
  }
  doMappingForPdf() {
    const noOfProducts = this.comparatorLabels.products.length;
    const { products } = this.comparatorLabels;
    const priceIdMap = this.doPricingMapping();
    const productIdsForCharecteristics = [];
    for (const item of Object.keys(this.comparatorCharacteristics.items)) {
      productIdsForCharecteristics.push(item);
    }
    const dataArray = [];
    for (let index = 0; index < noOfProducts; index += COMPARATOR_THRESHOLD) {
      const productsChunk = products.slice(index, index + COMPARATOR_THRESHOLD);
      const auxlixilaryProductInfo = this.comparatorPriceInfo.productsList.slice(index, index + COMPARATOR_THRESHOLD);
      const productsChunkPriceInfo = priceIdMap.slice(index, index + COMPARATOR_THRESHOLD);
      const productIds = productIdsForCharecteristics.slice(index, index + COMPARATOR_THRESHOLD);
      const mappedCharacteristics = comparatorMapCharacteristics(productIds, {
        keySections: this.comparatorCharacteristics.keySections,
        sections: this.comparatorCharacteristics.sections,
        items: this.comparatorCharacteristics.items,
      });
      dataArray.push({
        products: productsChunk,
        characteristics: mappedCharacteristics,
        prices: productsChunkPriceInfo,
        aux: auxlixilaryProductInfo,
      });
    }
    return dataArray;
  }
  render() {
    var _a, _b;
    let start = 1;
    const productsLength = (_b = (_a = this.comparatorLabels) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.length;
    const noOfTables = Math.ceil(productsLength / COMPARATOR_THRESHOLD);
    this.getWEEEPriceLabel();
    return (h("div", { class: "pdf-rtl-selector" }, h("pes-pdf-disclaimer", { disclaimer: this.comparatorLabels.labels.comparatorPdfDisclaimer }), this.showWeePriceLabel && h("pes-comparator-weee-price", { label: this.weePriceLabel }), h("pes-pdf-ltr-footer", { brand: this.brand }), this.doMappingForPdf().map((data, i) => {
      const NProducts = data.products.length;
      const startForThisRow = start;
      const end = NProducts + start - 1;
      start += NProducts;
      return (h("div", { class: classnames({ 'table-container': i + 1 !== noOfTables }, 'comparator-table') }, h("pes-comparator-header", { title: this.comparatorLabels.labels.comparatorPdfTitle, date: this.comparatorLabels.labels.comparatorPdfDate }), h("table", null, h("thead", { class: "main-container-comparator" }, h("pes-comparator-product-head", { products: data.products, prices: data.prices, aux: data.aux, labels: this.comparatorLabels.labels, start: startForThisRow, end: end, totalLength: productsLength })), h("tbody", null, h("pdf-comparator-table", { characteristicsMap: data.characteristics, totalProducts: NProducts })))));
    })));
  }
};
PesComparisonPdf.style = pesComparisonPdfCss;

export { PdfComparatorTable as pdf_comparator_table, PesComparatorHeader as pes_comparator_header, PesComparatorProductHead as pes_comparator_product_head, PesComparatorWeeePrice as pes_comparator_weee_price, PesComparisonPdf as pes_comparison_pdf };
